{
  "internalPortal": {
    "components": {
      "invoices": {
        "title": "Invoices"
      },
      "documents": {
        "title": "Documents",
        "editDialog": {
          "title": "Edit document",
          "tabs": {
            "basicInformation": "Basic information",
            "advanced": "Advanced"
          },
          "fields": {
            "name": "Name",
            "type": "Type",
            "vendor": "Vendor",
            "spendCategory": "Spend category",
            "tags": "Tags",
            "startDate": "Start date",
            "endDate": "End date",
            "renewalDate": "Renewal date",
            "nte": "NTE",
            "api": "API",
            "nft": "NFT",
            "markAsSensitiveData": "Mark as sensitive data",
            "visibility": "SpendBrain visibility",
            "internalOnly": "Internal only",
            "publishedToMicrosite": "Published to SpendBrain",
            "publishToMicrosite": "Show client",
            "unpublishFromMicrosite": "Mark as internal",
            "stage": "stage",
            "providedBy": "provided by",
            "uploadDate": "upload date"
          }
        },
        "table": {
          "columns": {
            "name": "Name",
            "type": "Type",
            "tags": "Tags",
            "providedBy": "Provided by",
            "spendCategory": "Spend category",
            "vendor": "Vendor",
            "stage": "Stage",
            "uploadDate": "Upload date",
            "renewalDate": "Renewal date",
            "subsidiaryOrganizationName": "Subsidiary organization name",
            "visibility": "SpendBrain visibility"
          },
          "internalDocumentsFilter": {
            "internalOnly": "Internal documents only",
            "tooltip": "Show only documents that are not visible to the client in SpendBrain."
          },
          "typesOverflowTriggerAriaLabel_one": "{{count}} more type — hover or focus to see all",
          "typesOverflowTriggerAriaLabel_other": "{{count}} more types — hover or focus to see all",
          "tagsOverflowTriggerAriaLabel_one": "{{count}} more tag — hover or focus to see all",
          "tagsOverflowTriggerAriaLabel_other": "{{count}} more tags — hover or focus to see all"
        },
        "actions": {
          "displayDocumentsAcrossSubsidiaries": "Display documents across subsidiaries",
          "downloadZip": "Download .ZIP",
          "deleteSuccess_one": "Document has been deleted successfully.",
          "deleteSuccess_other": "Documents have been deleted successfully.",
          "publishToMicrosite": {
            "success": "Document has been published to the client's SpendBrain.",
            "failure": "Failed to publish document to the client's SpendBrain."
          },
          "unpublishFromMicrosite": {
            "success": "Document is now internal-only and hidden from the client's SpendBrain.",
            "failure": "Failed to unpublish document from the client's SpendBrain."
          }
        },
        "deleteDialog": {
          "title_one": "Deleting document",
          "title_other": "Deleting documents",
          "description_one": "Are you sure you want to delete this document?",
          "description_other": "Are you sure you want to delete these documents?"
        },
        "noData": {
          "withoutFilters": {
            "title": "No documents found",
            "description": "No documents found. Upload documents using the button in the toolbar when available."
          }
        }
      }
    }
  }
}
